__turbopack_context__.v({
  "content": "IFOOkG_content",
});
